import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconThumbsDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12.445 9.375H8.41375V13.125C8.45338 13.3803 8.43222 13.6413 8.35201 13.8869C8.2718 14.1325 8.13479 14.3557 7.95211 14.5384C7.76943 14.721 7.54624 14.8581 7.30066 14.9383C7.05508 15.0185 6.79404 15.0396 6.53875 15C6.40761 14.991 6.28266 14.9408 6.18167 14.8566C6.08068 14.7725 6.0088 14.6586 5.97625 14.5313L3.75 7.5V2.86102e-06H11.7887C12.3849 0.0115414 12.9575 0.234811 13.404 0.629866C13.8506 1.02492 14.1421 1.56598 14.2262 2.15625L14.9762 6.46875C15.0353 6.81809 15.0154 7.1762 14.9181 7.51686C14.8207 7.85751 14.6484 8.17208 14.4137 8.4375C14.1855 8.7409 13.8872 8.9846 13.5444 9.14784C13.2016 9.31108 12.8244 9.38902 12.445 9.375Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.5 7.5H0V0H2.5V7.5Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white",
			transform: "matrix(1 0 0 -1 0 15)"
		})
	}) })]
});
export default SvgIconThumbsDown;
